function handleURLParamChange(){
    //console.log("url change test")
    setTimeout(() => {
      const kiwi = document.querySelector('div.ks-chart-container.sizing-chart-container.ks-container-with-modal');
      //console.log("container logged")
        if (!kiwi) {
          loadKiwiSizingChart();
        }
    }, "500");
  }
  
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;
  
  history.pushState = function() {
    originalPushState.apply(this, arguments);
    handleURLParamChange();
  };
  
  history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    handleURLParamChange();
  };
  
  
  
  setInterval(() => {
    const allCharts = document.querySelectorAll('div.ks-chart-container.sizing-chart-container.ks-container-with-modal');
    console.log("allCharts.length",allCharts.length)
    if (allCharts.length === 0) {

    } else if (allCharts.length > 1) {
      allCharts.forEach((chart, index) => {
        if (index > 0) chart.remove();
      });
    } else {
        
    }
  }, 500); 